import React from 'react';
import './Methodology.css';

// Import the icons we'll need for the timeline
import { FaGlobe, FaUsers, FaDatabase, FaFilter, FaCogs, FaShareAlt, FaComments } from 'react-icons/fa';

// Array of data for each step in the methodology
const methodologySteps = [
  { num: '01', title: 'DEFINING MARKET', icon: <FaGlobe /> },
  { num: '02', title: 'POOLING PARTICIPANTS', icon: <FaUsers /> },
  { num: '03', title: 'DATA COLLECTION', icon: <FaDatabase /> },
  { num: '04', title: 'DATA NORMALISATION', icon: <FaFilter /> },
  { num: '05', title: 'DATA RATIONALIZATION', icon: <FaCogs /> },
  { num: '06', title: 'DATA DISSEMINATION', icon: <FaShareAlt /> },
  { num: '07', title: 'FEEDBACK AND REVIEW', icon: <FaComments /> },
];

const Methodology = () => {
  return (
    <section className="methodology-section">
      <div className="methodology-container">
        {/* Left Column: Text Content */}
        <div className="methodology-text">
          <div className="section-header">
            <h2>How we discover prices</h2>
            <div className="header-line"></div>
          </div>
          <p>
            Our pricing is driven by a robust, scientific methodology. We track real-time trades, confirmed transactions, and market-verified deals from a diverse participant base.
          </p>
          <p>
            This data flows into our automated, tech-enabled pricing system, removing noise and bias to deliver accurate, transparent, and reliable prices.
          </p>
          <a href="/" className="methodology-link">View our price methodology &rarr;</a>
        </div>

        {/* Right Column: Infographic */}
        <div className="methodology-infographic">
          <svg className="wavy-line" viewBox="0 0 1000 100" preserveAspectRatio="none">
            <path d="M0,50 Q125,0 250,50 T500,50 T750,50 T1000,50" stroke="#D32F2F" fill="transparent" strokeWidth="2" />
          </svg>
          <div className="steps-container">
            {methodologySteps.map((step, index) => (
              <div key={index} className="step-item">
                <div className="step-title-top">{index % 2 !== 0 && step.title}</div>
                <div className="step-icon">{step.icon}</div>
                <div className="step-number">{step.num}</div>
                <div className="step-title-bottom">{index % 2 === 0 && step.title}</div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Methodology;